import styled from "styled-components";

export const Container = styled.div`
    position: absolute;
    right: 25px;
    top: 10px;
    
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    
`